module.exports = {
  title: '结算周期管理',
  route: {
    path: '/finance-manage',
    children: {
      path: 'settlement-cycle-manage',
    },
  },
};
